// removed by extract-text-webpack-plugin
module.exports = {"main":"Footer-main--2RWAJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapPanel/Footer/Footer.scss
// module id = H2II
// module chunks = 4